var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "mds-fieldset",
        {
          staticClass: "attestation-form__data-ditribution-fieldset",
          attrs: {
            legend: _vm.translate("scheduler.modal.delivery.attestation.title"),
            variation: "checkbox-group",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "attestation-form__data-ditribution-fieldset-checkbox",
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.isAccepted,
                    expression: "isAccepted",
                  },
                ],
                attrs: { type: "checkbox", id: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.isAccepted)
                    ? _vm._i(_vm.isAccepted, null) > -1
                    : _vm.isAccepted,
                },
                on: {
                  change: [
                    function ($event) {
                      var $$a = _vm.isAccepted,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.isAccepted = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.isAccepted = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.isAccepted = $$c
                      }
                    },
                    _vm.handleAgreementCheck,
                  ],
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "checkbox" } }, [
                _c(
                  "p",
                  {
                    staticClass:
                      "attestation-form__data-ditribution-fieldset-text",
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.translate(
                            "scheduler.modal.delivery.attestation.text.confirm"
                          )
                        ) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "attestation-form__data-ditribution-fieldset-text",
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.translate(
                            "scheduler.modal.delivery.attestation.text.limited.confirm"
                          )
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "mds-button",
            {
              staticClass: "attestation-form__data-ditribution-fieldset-button",
              attrs: {
                variation: "secondary",
                type: "button",
                size: "small",
                target: "_blank",
                href: _vm.licenseUrl,
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.translate("scheduler.modal.delivery.attestation.button")
                  ) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }